import {
  Button,
  Checkbox,
  CheckboxSelect,
  DefaultNumberInputField,
  Heading,
  Input,
  InputField,
  Link,
  TagComplete,
  Text,
} from '~/common/components/defaultUIComponents';
import ProjectPictureApi from '~/common/api/zeiterfassungServerApi/ProjectPictureApi';
import { CreateEditProjectSchema, useCreateEditProjectForm } from './utils';
import ProjectApi from '~/common/api/zeiterfassungServerApi/ProjectApi';
import { Box, Flex, FormLabel, Grid, Icon } from '@chakra-ui/react';
import { unstable_usePrompt as usePrompt } from 'react-router-dom';
import { ListView } from '~/common/components/ListView';
import routes from '~/common/constants/routes.json';
import useTranslate from '~/common/utils/translate';
import ProjectPicture from './ProjectPicture';
import { List } from '@material-ui/icons';
import { Form, Formik } from 'formik';
import React from 'react';

// TODO: Incorperate Taglist

export const CreateEditProjectScreen: React.FC = () => {
  const translate = useTranslate();
  const [{ data: options }] = ProjectApi.hooks.useProjectsQuery({
    select: (projects) => projects.filter((project) => project.is_option),
  });
  const { data: existingTags } = ProjectApi.hooks.useProjectTags({
    select: (tag) => tag.map((tag) => tag.tag),
  });
  const [search, setSearch] = React.useState('');
  const { initialValues, submit, project } = useCreateEditProjectForm();
  const [{ data: projectPicture }] =
    ProjectPictureApi.hooks.useProjectPictureQuery(
      { id: project?.id ?? -1 },
      { enabled: !!project },
    );
  const projectPictureString = projectPicture?.picture ?? null;

  return (
    <Flex>
      <Box width="66.67%" pr={4}>
        <Formik
          initialValues={initialValues}
          onSubmit={(values, helpers) => submit(values, helpers)}
          validationSchema={CreateEditProjectSchema}
          validateOnChange
          enableReinitialize
        >
          {({
            dirty,
            values,
            isSubmitting,
            isValid,
            setFieldValue,
            errors,
          }) => {
            usePrompt({
              when: dirty,
              message: translate('project.newProject.dirty') as string,
            });
            return (
              <Form>
                <Flex direction="column" gap={2} maxH="90vh">
                  <Heading mb={2}>
                    {!project
                      ? 'project.newProject.heading'
                      : 'project.editProject.heading'}
                  </Heading>
                  {project && (
                    <Link
                      href={routes.PROJECT.replace(':id', String(project.id))}
                    >
                      <Flex gap={1} _hover={{ cursor: 'pointer' }}>
                        <Box>
                          <Icon as={List} />
                        </Box>
                        <Text _hover={{ cursor: 'pointer' }}>
                          {translate('project.jobs')}
                        </Text>
                      </Flex>
                    </Link>
                  )}
                  <InputField
                    name="name"
                    label="project.newProject.input.name.label"
                    placeholder=""
                  />
                  <TagComplete
                    name="tags"
                    label="project.newProject.tags"
                    options={existingTags ?? []}
                  />
                  <Flex>
                    <Checkbox
                      isChecked={values.isOption}
                      name="isOption"
                      onChange={() =>
                        void setFieldValue('isOption', !values.isOption)
                      }
                    >
                      project.newProject.checkbox.isOption
                    </Checkbox>
                  </Flex>
                  <Grid
                    templateColumns="repeat(3, 1fr)"
                    alignItems="end"
                    columnGap={3}
                    mt={3}
                  >
                    <DefaultNumberInputField
                      min={0}
                      name="hours"
                      label="project.newProject.input.calculatedTime.hours"
                      w="full"
                    />
                    <DefaultNumberInputField
                      min={0}
                      max={60}
                      name="minutes"
                      label="project.newProject.input.calculatedTime.minutes"
                      w="full"
                    />
                  </Grid>
                  <Flex>
                    <Text color="red.600">{errors.duration}</Text>
                  </Flex>
                  {!values.isOption && (
                    <>
                      <FormLabel mt={3}>
                        {translate('project.newProject.input.options')}
                      </FormLabel>
                      <ListView
                        data={options}
                        searchFields={(p) => [p.name]}
                        search={search}
                        mt={3}
                        render={({ data }) => {
                          {
                            return (
                              <>
                                <Input
                                  label=""
                                  placeholder="projectModalBone.searchProjects.input.placeholder"
                                  onChange={(e) => setSearch(e.target.value)}
                                  mb={4}
                                />
                                <CheckboxSelect
                                  name="subProjectIds"
                                  columns={4}
                                  fields={data}
                                  orderBy={(p) => p.name.toLowerCase()}
                                  labels={(project) => {
                                    return project.name;
                                  }}
                                  values={(project) => {
                                    return project.id;
                                  }}
                                  keys={(project) => {
                                    return project.id;
                                  }}
                                  boxProps={{
                                    maxH: '50vh',
                                    overflowY: 'scroll',
                                  }}
                                />
                              </>
                            );
                          }
                        }}
                      />
                    </>
                  )}
                </Flex>
                <Box
                  position="fixed"
                  zIndex={2}
                  bottom={0}
                  left={0}
                  px={5}
                  pb={3}
                  w="full"
                >
                  <Button
                    type="submit"
                    isLoading={isSubmitting}
                    isDisabled={!isValid}
                    w="full"
                  >
                    {!project
                      ? 'project.newProject.submitText'
                      : 'projectTile.editProject.submitText'}
                  </Button>
                </Box>
              </Form>
            );
          }}
        </Formik>
      </Box>
      <Box width="33.33%" pl={4}>
        <Heading mb={2}>project.createEditProject.projectPicture</Heading>
        <ProjectPicture
          initialImage={projectPictureString}
          projectId={project?.id ?? -1}
        />
      </Box>
    </Flex>
  );
};
